const initialState = () => ({
    modals: [],
    forceModal: null
})

export default {
    namespaced: true,
    state: initialState(),
    mutations: {
        OPEN_MODAL (state, { name, props }) {
            state.modals.push({ name, props })
        },
        CLOSE_LAST_MODAL (state) {
            state.modals.pop()
        },
        SET_MODAL_TO_FORCE (state, { modal }) {
            state.forceModal = modal
        }
    },
    getters: {
        modals: state => state.modals,
        forceModal: state => state.forceModal
    }
}



// WEBPACK FOOTER //
// ./src/stores/modals.js